"use client"

import { useTERouter } from "@/hooks/app/useTERouter"
import { getQueryStringSearchHotel } from "@/utils/hotel/getQueryStringSearchHotel"
import { getQueryStringPartner } from "@/utils/string/getQueryStringPartner"
import { usePathname, useSearchParams } from "next/navigation"
import { useCallback } from "react"

const HOTEL_CRITERIA_KEYS = new Set([
  "adt",
  "child",
  "room",
  "in",
  "out",
  "loc",
  "type",
  "children_ages",
])

export const useHotelSearchUrlSync = () => {
  const router = useTERouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  return useCallback(() => {
    if (!pathname?.includes("/hotels/")) return

    const merged = new URLSearchParams()

    searchParams.forEach((value, key) => {
      if (!HOTEL_CRITERIA_KEYS.has(key)) {
        merged.append(key, value)
      }
    })

    new URLSearchParams(getQueryStringSearchHotel()).forEach((value, key) => {
      merged.delete(key)
      merged.append(key, value)
    })

    const partnerQs = getQueryStringPartner()
    if (partnerQs) {
      new URLSearchParams(partnerQs).forEach((value, key) => {
        merged.set(key, value)
      })
    }

    const qs = merged.toString()
    router.replace(qs ? `${pathname}?${qs}` : pathname, { scroll: false })
  }, [pathname, router, searchParams])
}
